<template>
  <div>
    <!-- Header -->
    <div class="d-md-flex align-items-center">
      <div>
        <h3 class="card-title">Rozkład wydanych punktów</h3>
        <h5 class="card-subtitle text-muted font-weight-normal">Podział na typy kuponów</h5>
      </div>
    </div>
    <!-- Chart and details section -->
    <vs-row class="mt-5">
      <vs-col vs-lg="6" vs-xs="12" vs-sm="6">
        <vue-apex-charts type="donut" height="290" :options="apexChartData.donutChart.chartOptions" :series="series">
        </vue-apex-charts>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12" vs-sm="6">
        <h1 class="display-6 mb-0 font-medium">Kupione kupony</h1>
        <span>Procentowy przydział kupionych kuponów pieniężnych</span>
        <ul class="list-inline">
          <li class="mt-3">
            <i class="mdi mdi-checkbox-blank-circle mr-1 text-info font-12"></i> Kupon 10 PLN
            <span class="float-right">{{voucher_amounts["10"]}}</span>
          </li>
          <li class="mt-3">
            <i class="mdi mdi-checkbox-blank-circle mr-1 text-warning font-12"></i> Kupon 20 PLN
            <span class="float-right">{{voucher_amounts["20"]}}</span>
          </li>
          <li class="mt-3">
            <i class="mdi mdi-checkbox-blank-circle mr-1 text-danger font-12"></i> Kupon 50 PLN
            <span class="float-right">{{voucher_amounts["50"]}}</span>
          </li>
          <li class="mt-3">
            <i class="mdi mdi-checkbox-blank-circle mr-1 text-primary font-12"></i> Kupon 100 PLN
            <span class="float-right">{{voucher_amounts["100"]}}</span>
          </li>
        </ul>
      </vs-col>
    </vs-row>
  </div>
</template>
<script>
  import VueApexCharts from "vue-apexcharts";
  import apexChartData from "../../../charts/apexcharts/ApexChartsData";

  export default {
    name: "EmailCampaign",
    props: {
      voucher_amounts: {
        required: true
      }
    },
    data: () => ({
      title: "EmailCampaign",
      apexChartData: apexChartData
    }),
    components: {
      VueApexCharts
    },
    computed: {
      series: function () {
        if (this.voucher_amounts["10"] == '0' && this.voucher_amounts["20"] == '0' && this.voucher_amounts["50"] ==
          '0' && this.voucher_amounts["100"] == '0') return [25, 25, 25, 25];
        else {
          let sum = this.voucher_amounts["10"] + this.voucher_amounts["20"] + this.voucher_amounts["50"] + this
            .voucher_amounts["100"];

          let arr = [
            Number((this.voucher_amounts["10"] / sum * 100).toFixed(2)),
            Number((this.voucher_amounts["20"] / sum * 100).toFixed(2)),
            Number((this.voucher_amounts["50"] / sum * 100).toFixed(2)),
            Number((this.voucher_amounts["100"] / sum * 100).toFixed(2))
          ];
          return arr;
        }
      }
    }
  };

</script>
